import axios from 'axios';

export default axios.create({
    baseURL: 'http://85.159.27.198:8080/abitur/api/auth/signin'
});